import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import CareFacilityListings from "../components/Admin/CareFacility/CareFacilityListings";

function CareFacilityListingsPage() {
  return (
    <>
    <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={false} />
                </div>
              <div className="content-class">
                <CareFacilityListings />
              </div>
              <div className="footer-class">
                  <Footer />
              </div>
            </div>
      </div>
    </>
  );
}

export default CareFacilityListingsPage;
